var exports = {
  "t": "ContributorFooter__83sXqv",
};

module.exports = exports;
